import { render, staticRenderFns } from "./PackageManage.vue?vue&type=template&id=06394509&scoped=true&"
import script from "./PackageManage.vue?vue&type=script&lang=js&"
export * from "./PackageManage.vue?vue&type=script&lang=js&"
import style0 from "./PackageManage.vue?vue&type=style&index=0&id=06394509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06394509",
  null
  
)

export default component.exports